import { useEffect } from 'react';
import { enqueueSnackbar, VariantType } from 'notistack';

interface AuthMessagePayload {
  message?: string;
  message_variant?: VariantType | undefined;
  params?: {
    email?: string;
  };
}

export const useAuthErrorMessage = (f: (a: AuthMessagePayload) => void) =>
  useEffect(() => {
    const url = new URL(window.location.href);
    let auth = url.searchParams.get('auth') as string | undefined;
    if (auth) {
      auth = window.atob(auth);
      const authMessagePayload: AuthMessagePayload = JSON.parse(auth);

      const { message } = authMessagePayload;

      if (message) {
        const variant = authMessagePayload.message_variant || 'default';
        enqueueSnackbar(message, { variant });
      }
      url.searchParams.delete('auth');
      window.history.replaceState(null, '', url); // or pushState
      if (f) f(authMessagePayload);
    }
  }, []);
